import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Breadcrumb, Flex, Tabs, Button } from "antd";
import TabPermissionsSuperAdmin from "./component/TabPermissionsSuperAdmin";
import TabPermissionsWealthAdmin from "./component/TabPermissionsWealthAdmin";
import TabPermissionsWealthAdvisor from "./component/TabPermissionsWealthAdvisor";

import StyledContainer from "./style";

import { setPhoneMask } from "../../../../../../../../utils/helper/general";
import {
  isTypeLevelWealthAdvisor,
  isTypeLevelWealthEnterpriseAdmin,
  isTypeLevelWealthEnterpriseAdminAdvisor,
  isTypeSuperAdmin,
} from "../../../../helper";

import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import { ReactComponent as DotSeparator } from "../../../../image/dot_separator.svg";

const SectionUserPermission = ({
  disableEdit,
  handleEditActiveClient,
  handleLaunch,
  handleViewFolders,
  itemsBreadcrumb,
  loading,
  submitPermissions,
  userData,
  userTypes,
}) => {
  const items = [
    {
      children: (
        <TabPermissionsWealthAdmin
          clientPermissions={userData?.permissions}
          disableEdit={disableEdit}
          handleSave={submitPermissions}
          loading={loading}
        />
      ),
      key: "levelWealthEnterpriseAdmin",
      label: "Admin Permissions",
      visible:
        userData?.company?.type === "LevelWealth" &&
        (isTypeLevelWealthEnterpriseAdmin(userData?.type) ||
          isTypeLevelWealthEnterpriseAdminAdvisor(userData?.type)),
    },
    {
      children: (
        <TabPermissionsWealthAdvisor
          clientPermissions={userData?.permissions}
          disableEdit={disableEdit}
          handleSave={submitPermissions}
          handleViewFolders={handleViewFolders}
          loading={loading}
        />
      ),
      key: "levelWealthEnterpriseAdminAdvisor",
      label: "Advisor Permissions",
      visible: isTypeLevelWealthEnterpriseAdminAdvisor(userData?.type),
    },
    {
      children: (
        <TabPermissionsSuperAdmin
          clientPermissions={userData?.permissions}
          disableEdit={disableEdit}
          handleSave={submitPermissions}
          loading={loading}
        />
      ),
      key: "superAdmin",
      label: "Permissions",
      visible: isTypeSuperAdmin(userData?.type),
    },
    {
      children: (
        <TabPermissionsWealthAdvisor
          clientPermissions={userData?.permissions}
          disableEdit={disableEdit}
          handleSave={submitPermissions}
          handleViewFolders={handleViewFolders}
          loading={loading}
        />
      ),
      key: "levelWealthAdvisor",
      label: "Permissions",
      visible: isTypeLevelWealthAdvisor(userData?.type),
    },
  ].filter(it => it.visible);

  return (
    <StyledContainer>
      {itemsBreadcrumb && (
        <Breadcrumb
          items={itemsBreadcrumb}
          separator={<DotSeparator style={{ color: "#C9C8C8" }} />}
        />
      )}

      <header>
        <Flex gap={4} vertical>
          <Flex justify="space-between">
            <Flex align="center" gap={16}>
              <h2>
                {userData?.firstName} {userData?.lastName}
              </h2>
              <Button
                disabled={loading}
                icon={<FontAwesomeIcon icon={faPenToSquare} />}
                onClick={handleEditActiveClient}
                shape="round"
                size="small"
                style={{ height: 28, minHeight: 28 }}
              />
            </Flex>

            {handleLaunch && (
              <Button
                onClick={handleLaunch}
                shape="round"
                size="small"
                style={{
                  background: "#DBE245",
                  fontWeight: 800,
                }}
              >
                Launch
              </Button>
            )}
          </Flex>

          <Flex align="center" gap={8}>
            {userData?.company?.name}
            <DotSeparator />
            {userTypes?.find(it => it.type === userData?.type)?.displayName ??
              userData?.type}
            <DotSeparator />
            {userData?.email}
            <DotSeparator />
            {setPhoneMask(userData?.phone)}
          </Flex>
        </Flex>
      </header>
      {items.length ? <Tabs items={items} /> : ""}
    </StyledContainer>
  );
};

export default SectionUserPermission;
